<template>
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12 sm6 md4 v-for="liste in listes" :key="liste.id">
          <v-layout ma-2>
            <v-card dark hover class="card" :to="{name: 'liste', params: {id: liste.id}}">
                <v-card-title>{{ liste.nom }}</v-card-title>
                <v-card-text class="light-blue--text text--lighten-4 blue-grey darken-3">{{ liste.type }}</v-card-text>
            </v-card>
            <v-btn icon @click="remove(liste.id)">
              <v-icon color="red lighten-2" large>remove_circle</v-icon>
            </v-btn>
          </v-layout>        
        </v-flex>
        <v-flex xs12>
            <popup :liste="listes" @projectAdded="snackbar = true" />
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import Popup from '@/components/Popup'

export default {
  data() {
    return {
      listes: this.$store.state.listes,
      snackbar: false
    }
  },
  components: {
    Popup
  },
  methods: {
    remove(index) {
      this.$store.dispatch('supprListe', index);
    }
  }
}
</script>

<style lang="scss" scoped>
  .card {
    border-radius: 10px;
    width: 80%;
  }
</style>


